import React, { useEffect, useState, Fragment, createElement, Component } from 'react';
import { Check, Star, Heart, Clock, Shield, Users, ArrowRight, Gift, BookOpen, Smile } from 'lucide-react';
// --- Assets ---
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/83VDL6ws5G9XeTQM77ivZJ/20251228_1809_Libro_Educativo_Inclusivo_simple_compose_01kdkcnn1me3gvbqgpabhct6qp.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/iXYqX6Zohg7aATyuYrGhUz/20250915_1349_Mega_Pack_Colorido_simple_compose_01k574bnvwe0jawp8pg8yea8a9.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/wthoCTVf3WtrTCF7GtNqMd/20250915_1404_Mini_Pack_Colorido_simple_compose_01k575554hres398q1ty5dmx3jh.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/6P9QdrQMbtk1SiDLfSziLz/20250915_1412_Guia_Express_de_Emociones_simple_compose_01k575p68gfnvswtjszyacpv1q.png'
};
const PURCHASE_LINK = 'https://www.onlinepack.shop/cart/44633695027254:1';
// Declare fbq on window for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// --- Meta Pixel Initialization ---
const initMetaPixel = () => {
  // Check if already initialized
  if (window.fbq) return;
  // Create the fbq function
  const fbq: any = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  // Create and inject the script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  // Initialize pixel
  fbq('init', '1084918860262171');
  fbq('track', 'PageView');
  // Add noscript fallback
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1084918860262171&ev=PageView&noscript=1';
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};
// --- Components ---
const Button = ({
  children,
  className = '',
  variant = 'primary',
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  onClick?: () => void;
}) => {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#FF8C42] text-white hover:bg-[#ff7a25] shadow-lg shadow-orange-200 focus:ring-[#FF8C42]',
    secondary: 'bg-[#4DB8B8] text-white hover:bg-[#3da0a0] shadow-lg shadow-teal-200 focus:ring-[#4DB8B8]',
    outline: 'border-2 border-[#4DB8B8] text-[#4DB8B8] hover:bg-[#4DB8B8] hover:text-white'
  };
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const element = document.getElementById('purchase-section');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-0">
      {children}
    </button>;
};
const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <section id={id} className={`py-8 md:py-12 px-4 md:px-8 ${className}`} data-id="element-1">
    <div className="max-w-4xl mx-auto" data-id="element-2">{children}</div>
  </section>;
const Card = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`bg-white rounded-2xl shadow-xl p-8 ${className}`} data-id="element-3">
    {children}
  </div>;
const PurchasePopup = () => {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  const names = ['María', 'Ana', 'Lucía', 'Carmen', 'Laura', 'Sofía', 'Valentina', 'Camila', 'Isabella', 'Fernanda'];
  const cities = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Caracas', 'Quito', 'Montevideo', 'Asunción', 'Córdoba'];
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showNotification, 15000);
    // Recurring interval
    const interval = setInterval(showNotification, 45000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:left-4 md:right-auto md:w-80 bg-white rounded-xl shadow-2xl p-4 z-50 animate-fade-in-up border-l-4 border-[#4DB8B8] flex items-center gap-4" data-id="element-4">
      <div className="bg-[#E6F7F7] p-2 rounded-full" data-id="element-5">
        <Users className="w-6 h-6 text-[#4DB8B8]" data-id="element-6" />
      </div>
      <div data-id="element-7">
        <p className="text-sm font-bold text-gray-800" data-id="element-8">
          {notification.name} de {notification.city}
        </p>
        <p className="text-xs text-gray-600" data-id="element-9">acaba de adquirir el Mega Pack</p>
      </div>
    </div>;
};
const Testimonial = ({
  name,
  role,
  quote,
  image
}: {
  name: string;
  role: string;
  quote: string;
  image: string;
}) => <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-10">
    <div className="flex items-center gap-4 mb-4" data-id="element-11">
      <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden" data-id="element-12">
        <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-13" />
      </div>
      <div data-id="element-14">
        <h4 className="font-bold text-gray-800" data-id="element-15">{name}</h4>
        <p className="text-xs text-[#4DB8B8] font-medium" data-id="element-16">{role}</p>
      </div>
    </div>
    <div className="flex text-[#FFD166] mb-3" data-id="element-17">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-18" />)}
    </div>
    <p className="text-gray-600 italic text-sm leading-relaxed" data-id="element-19">"{quote}"</p>
  </div>;
// --- Main Application ---
export function App() {
  // Initialize Meta Pixel on component mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#FFFDF9] font-sans text-gray-800 selection:bg-[#FFD166] selection:text-gray-900" data-id="element-20">
      <PurchasePopup data-id="element-21" />

      {/* Hero Section */}
      <header className="relative bg-gradient-to-b from-[#E6F7F7] to-[#FFFDF9] pt-8 pb-12 overflow-hidden" data-id="element-22">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#4DB8B8] via-[#FFD166] to-[#FF8C42]" data-id="element-23"></div>

        <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-24">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-25">
            <div className="flex-1 text-center md:text-left z-10" data-id="element-26">
              <span className="inline-block px-4 py-1 bg-[#FFD166] text-gray-900 rounded-full text-sm font-bold mb-4 tracking-wide uppercase" data-id="element-27">
                Para docentes de primaria e inicial
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-28">
                MEGA PACK <span className="text-[#4DB8B8]" data-id="element-29">INCLUSIVO</span>{' '}
                INFANTIL
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 mb-6 leading-relaxed" data-id="element-30">
                El sistema que te devuelve la tranquilidad en el aula, cuando
                querés ayudar a todos tus alumnos y sentís que no llegás.
              </p>
              <Button className="w-full md:w-auto text-lg shadow-xl shadow-orange-200/50" data-id="element-31">
                Accede al sistema que cambiará tu aula HOY
              </Button>
            </div>

            <div className="flex-1 relative" data-id="element-32">
              <div className="absolute inset-0 bg-[#FFD166] rounded-full filter blur-3xl opacity-20 animate-pulse" data-id="element-33"></div>
              <img src={IMAGES.main} alt="Mega Pack Inclusivo Infantil" className="relative z-10 w-full max-w-md mx-auto transform hover:scale-105 transition-transform duration-500 cursor-pointer drop-shadow-2xl" onClick={() => document.getElementById('purchase-section')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-34" />
            </div>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <Section className="bg-white" data-id="element-35">
        <div className="prose prose-lg mx-auto text-gray-600" data-id="element-36">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-37">
            Si sos docente de primaria o inicial y tenés alumnos con NEE…
          </h2>
          <p className="mb-6" data-id="element-38">
            Y cada día entrás al aula con una mezcla de compromiso, cansancio y
            una pregunta que nadie responde — "¿Estoy haciendo lo suficiente?"—
            dejame decirte algo importante.
          </p>
          <p className="mb-6 text-lg" data-id="element-39">
            No es falta de ganas. No es falta de amor por tu trabajo. Es el peso
            de intentar incluir sin las herramientas adecuadas.
          </p>
          <div className="bg-red-50 border-l-4 border-red-400 p-6 my-8 rounded-r-xl" data-id="element-40">
            <h3 className="font-bold text-red-800 text-xl mb-3" data-id="element-41">
              ❗ Lo que tenés que saber (y nadie te dice)
            </h3>
            <p className="font-bold text-red-800 m-0" data-id="element-42">
              No es que seas mala docente. No es que te falte vocación. No es
              que no quieras incluir.
            </p>
          </div>
          <p className="text-lg font-medium text-gray-700 mb-8" data-id="element-43">
            Lo que pasa es que te están pidiendo inclusión real, con tiempos
            imposibles, recursos insuficientes y sin un sistema que te acompañe.
          </p>
          <p className="text-xl font-bold text-center text-[#4DB8B8] mb-8" data-id="element-44">
            👉 Te falta un sistema que te sostenga.
          </p>
          <p className="mb-6" data-id="element-45">
            Porque hoy, incluir no es incluir. Es sobrevivir.
          </p>
          <p className="mb-6" data-id="element-46">
            Improvisás adaptaciones a último momento. Buscás actividades que
            "más o menos" funcionen. Probás cosas que no enganchan. Te llevás
            trabajo a casa todos los días. Y entrás al aula con una sensación
            que no te deja tranquila:
          </p>
          <p className="italic text-center text-gray-500 text-xl mb-8" data-id="element-47">
            "Ojalá hoy pueda llegar a todos..."
          </p>
          <p className="mb-6 font-medium" data-id="element-48">
            No estás cansada. Estás sobrecargada.
            <br data-id="element-49" />
            No estás fallando. Estás intentando incluir sin herramientas reales.
          </p>
        </div>
      </Section>

      {/* The Real Problem */}
      <Section className="bg-[#FFFDF9]" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-52">
            EL PROBLEMA REAL NO ES TUYO
          </h2>
          <div className="w-24 h-1 bg-[#FF8C42] mx-auto rounded-full" data-id="element-53"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-54">
          <div data-id="element-55">
            <p className="text-lg text-gray-700 mb-6" data-id="element-56">
              El problema no es que no te importe. El problema es que el sistema
              educativo te pide inclusión real, pero no te da recursos reales.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-57">Te piden que:</p>
            <ul className="space-y-3" data-id="element-58">
              {['Incluyas', 'Adaptes', 'Contengas', 'Personalices', 'Evalúes distinto', 'Resuelvas conductas', 'Regules emociones', 'Acompañes ritmos diferentes'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-59">
                  <div className="w-6 h-6 rounded-full bg-[#FFD166] flex items-center justify-center flex-shrink-0" data-id="element-60">
                    <Check size={14} className="text-gray-900" data-id="element-61" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden" data-id="element-62">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#4DB8B8] opacity-10 rounded-bl-full" data-id="element-63"></div>
            <p className="text-xl font-bold text-gray-800 mb-4" data-id="element-64">
              Y todo eso… 👉 sin darte una estructura clara para hacerlo.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-65">
              Ahí aparece el desgaste invisible: mental, emocional y silencioso.
            </p>
            <p className="text-gray-600 font-medium" data-id="element-66">
              Ese cansancio que no se va. Esa culpa que nadie ve. Esa sensación
              constante de "no estoy llegando".
            </p>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-67">
          <Button variant="secondary" data-id="element-68">Necesito una solución ahora</Button>
        </div>
      </Section>

      {/* The Solution */}
      <Section className="bg-[#4DB8B8] text-white relative overflow-hidden" data-id="element-69">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-70"></div>

        <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-72">
            LO QUE REALMENTE NECESITÁS
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-73">
            No necesitás más teoría. No necesitás otro curso largo. No necesitás
            ideas sueltas de internet.
          </p>
          <div className="bg-white text-gray-900 p-8 rounded-2xl shadow-2xl transform md:scale-110 my-12" data-id="element-74">
            <h3 className="text-2xl font-bold text-[#FF8C42] mb-6" data-id="element-75">
              👉 Necesitás un sistema inclusivo armado.
            </h3>
            <ul className="text-left space-y-4" data-id="element-76">
              {['Te diga qué hacer con cada alumno', 'Te dé actividades adaptadas listas', 'Te permita incluir sin rehacer toda la clase', 'Te devuelva tiempo y seguridad', 'Te saque el peso de improvisar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-77">
                  <Check className="text-[#4DB8B8] flex-shrink-0 mt-1" data-id="element-78" />
                  <span className="font-medium" data-id="element-79">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Section>

      {/* Product Intro */}
      <Section className="bg-white" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <span className="text-[#FF8C42] font-bold tracking-wider uppercase text-sm" data-id="element-82">
            Presentamos
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-2 mb-6" data-id="element-83">
            MEGA PACK INCLUSIVO INFANTIL
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-84">
            Un sistema práctico de recursos inclusivos listos para usar, creado
            para docentes reales, con aulas reales y tiempos reales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-85">
          <div className="order-2 md:order-1" data-id="element-86">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-87">
              ¿QUÉ INCLUYE?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-88">
              El pack está pensado para que no tengas que inventar nada.
            </p>

            <div className="space-y-6" data-id="element-89">
              {[{
              icon: BookOpen,
              title: 'Mas de 500 actividades prácticas adaptadas',
              desc: 'Para diferentes ritmos y necesidades – Con sentido pedagógico real'
            }, {
              icon: Heart,
              title: 'Recursos para atención, lenguaje y regulación emocional',
              desc: 'Para acompañar sin improvisar'
            }, {
              icon: Shield,
              title: 'Material inclusivo organizado',
              desc: 'Todo clasificado y listo'
            }, {
              icon: Gift,
              title: 'Material visual y significativo',
              desc: 'Para enganchar y sostener el aprendizaje'
            }, {
              icon: Users,
              title: 'Imprimible y editable',
              desc: 'Para aula presencial o virtual'
            }].map((feature, i) => <div key={i} className="flex gap-4" data-id="element-90">
                  <div className="w-12 h-12 rounded-xl bg-[#E6F7F7] flex items-center justify-center flex-shrink-0 text-[#4DB8B8]" data-id="element-91">
                    <feature.icon size={24} data-id="element-92" />
                  </div>
                  <div data-id="element-93">
                    <h4 className="font-bold text-gray-900" data-id="element-94">{feature.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-95">{feature.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="order-1 md:order-2 flex justify-center" data-id="element-96">
            <img src={IMAGES.main} alt="Contenido del Pack" className="w-full max-w-md drop-shadow-2xl transform hover:rotate-2 transition-transform duration-500 cursor-pointer" onClick={() => document.getElementById('purchase-section')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-97" />
          </div>
        </div>
      </Section>

      {/* How it works */}
      <Section className="bg-[#FFFDF9]" data-id="element-98">
        <div className="text-center max-w-3xl mx-auto" data-id="element-99">
          <h2 className="text-3xl font-bold text-gray-900 mb-12" data-id="element-100">
            ¿CÓMO SE USA?
          </h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0" data-id="element-101">
            {['Abrís', 'Elegís', 'Aplicás', 'Incluís'].map((step, i, arr) => <Fragment key={i} data-id="element-102">
                <div className="flex flex-col items-center" data-id="element-103">
                  <div className="w-20 h-20 rounded-full bg-white border-4 border-[#FFD166] flex items-center justify-center text-xl font-bold text-gray-800 shadow-lg mb-4" data-id="element-104">
                    {i + 1}
                  </div>
                  <span className="font-bold text-lg text-gray-800" data-id="element-105">
                    {step}
                  </span>
                </div>
                {i < arr.length - 1 && <ArrowRight className="hidden md:block text-gray-300 w-8 h-8 mx-4" data-id="element-106" />}
              </Fragment>)}
          </div>
          <p className="mt-12 text-xl text-gray-600 font-medium" data-id="element-107">
            Sin correr. Sin rehacer todo. Sin agotarte.
          </p>
        </div>
      </Section>

      {/* Benefits */}
      <Section className="bg-[#FFD166] bg-opacity-10" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-110">
            CUANDO LO USÁS, PASA ESTO:
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-111">
          {['Entrás al aula más tranquila', 'Tenés opciones reales para cada alumno', 'Las actividades funcionan mejor', 'Hay menos frustración', 'Vos ganás seguridad'].map((benefit, i) => <Card key={i} className="text-center hover:scale-105 transition-transform duration-300" data-id="element-112">
              <Smile className="w-10 h-10 text-[#FF8C42] mx-auto mb-4" data-id="element-113" />
              <p className="font-bold text-gray-800" data-id="element-114">{benefit}</p>
            </Card>)}
        </div>
        <div className="text-center" data-id="element-115">
          <p className="text-2xl font-bold text-[#4DB8B8] mb-8" data-id="element-116">
            Y algo muy importante vuelve: 👉 La tranquilidad docente.
          </p>
          <p className="text-gray-600 mb-8" data-id="element-117">
            Esa sensación de saber que no estás sola.
          </p>
          <Button data-id="element-118">Sí, quiero el Mega Pack ahora</Button>
        </div>
      </Section>

      {/* Origin Story */}
      <Section className="bg-white" data-id="element-119">
        <div className="max-w-3xl mx-auto bg-[#E6F7F7] rounded-3xl p-8 md:p-12 border border-[#4DB8B8]/20" data-id="element-120">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-121">
            ESTO NACIÓ PORQUE…
          </h3>
          <p className="text-lg text-gray-700 mb-6" data-id="element-122">
            Docentes reales dijeron algo que se repite todos los días:
          </p>
          <p className="text-xl font-bold text-[#4DB8B8] italic mb-6 text-center" data-id="element-123">
            "Quiero incluir, pero no sé cómo hacerlo sin agotarme."
          </p>
          <p className="text-gray-700" data-id="element-124">
            Mega Pack Inclusivo Infantil nació para eso. No como teoría. No como
            exigencia.
            <br data-id="element-125" />
            <br data-id="element-126" />
            Sino como una caja de herramientas inclusivas que te acompaña.
          </p>
        </div>
      </Section>

      {/* Testimonials */}
      <Section className="bg-[#FFFDF9]" data-id="element-127">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-128">
          Lo que dicen otras docentes
        </h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-129">
          <Testimonial name="Laura Méndez" role="Docente de 2º Grado" image="https://randomuser.me/api/portraits/women/44.jpg" quote="Antes pasaba mis fines de semana buscando material. Con el Mega Pack, tengo todo organizado. Mis alumnos con TDAH están mucho más enganchados y yo recuperé mi tiempo libre." data-id="element-130" />
          <Testimonial name="Carolina Ruiz" role="Maestra Integradora" image="https://randomuser.me/api/portraits/women/68.jpg" quote="Es la primera vez que encuentro un material que realmente entiende lo que pasa en el aula. Las actividades de regulación emocional cambiaron el clima de mi clase por completo." data-id="element-131" />
          <Testimonial name="Valentina Torres" role="Docente de Inicial" image="https://randomuser.me/api/portraits/women/33.jpg" quote="Sentía mucha culpa por no llegar a todos. Este sistema me dio la seguridad que necesitaba. Ahora sé qué hacer y cómo adaptar rápido. ¡Gracias!" data-id="element-132" />
          <div className="md:hidden" data-id="element-133">
            <Testimonial name="Ana García" role="Docente de 4º Grado" image="https://randomuser.me/api/portraits/women/12.jpg" quote="Increíble la cantidad de recursos. Lo uso todos los días. Vale cada centavo por la tranquilidad que te da." data-id="element-134" />
          </div>
          <div className="md:hidden" data-id="element-135">
            <Testimonial name="Sofía P." role="Psicopedagoga" image="https://randomuser.me/api/portraits/women/28.jpg" quote="Lo recomiendo a todas las docentes que asesoro. Es práctico, visual y muy completo." data-id="element-136" />
          </div>
        </div>
      </Section>

      {/* Bonuses */}
      <Section className="bg-gradient-to-b from-white to-[#FFFDF9]" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <span className="bg-[#FF8C42] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-139">
            Solo por hoy
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mt-4 mb-4" data-id="element-140">
            LLEVATE ESTOS BONOS GRATIS
          </h2>
          <p className="text-gray-600" data-id="element-141">
            Complementos perfectos para potenciar tu aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-142">
          {[{
          img: IMAGES.bonus1,
          title: 'Mega Pack Colorido',
          val: '$5.000'
        }, {
          img: IMAGES.bonus3,
          title: 'Guía Express de Emociones',
          val: '$4.000'
        }].map((bonus, i) => <div key={i} className="group cursor-pointer" onClick={() => document.getElementById('purchase-section')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-143">
              <div className="relative mb-6 transform group-hover:scale-105 transition-transform duration-300" data-id="element-144">
                <div className="absolute top-4 right-4 bg-[#FFD166] text-gray-900 font-bold px-3 py-1 rounded-lg shadow-md z-10" data-id="element-145">
                  GRATIS HOY
                </div>
                <img src={bonus.img} alt={bonus.title} className="w-full rounded-xl shadow-lg" data-id="element-146" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-147">
                {bonus.title}
              </h3>
              <p className="text-gray-500 line-through" data-id="element-148">Valor: {bonus.val}</p>
            </div>)}
        </div>
      </Section>

      {/* Purchase Section */}
      <section id="purchase-section" className="py-12 px-4 bg-[#4DB8B8] relative overflow-hidden" data-id="element-149">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-150"></div>

        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden relative z-10" data-id="element-151">
          <div className="bg-[#FFD166] py-4 text-center" data-id="element-152">
            <p className="text-gray-900 font-bold text-lg uppercase tracking-wider" data-id="element-153">
              Oferta Especial Limitada
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-154">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-155">
              Mega Pack Inclusivo Infantil
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-156">
              Todo lo que necesitás para incluir con seguridad, ahorrar tiempo y
              recuperar tu tranquilidad docente.
            </p>

            <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-10" data-id="element-157">
              <div className="text-left space-y-2" data-id="element-158">
                <div className="flex items-center gap-2 text-gray-700" data-id="element-159">
                  <Check size={20} className="text-[#4DB8B8]" data-id="element-160" />
                  <span data-id="element-161">+500 Actividades Adaptadas</span>
                </div>
                <div className="flex items-center gap-2 text-gray-700" data-id="element-162">
                  <Check size={20} className="text-[#4DB8B8]" data-id="element-163" />
                  <span data-id="element-164">Recursos de Regulación Emocional</span>
                </div>
                <div className="flex items-center gap-2 text-gray-700" data-id="element-165">
                  <Check size={20} className="text-[#4DB8B8]" data-id="element-166" />
                  <span data-id="element-167">2 Bonos Exclusivos GRATIS</span>
                </div>
                <div className="flex items-center gap-2 text-gray-700" data-id="element-168">
                  <Check size={20} className="text-[#4DB8B8]" data-id="element-169" />
                  <span data-id="element-170">Acceso Inmediato y de por vida</span>
                </div>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200" data-id="element-171">
                <p className="text-gray-500 text-sm mb-1 line-through" data-id="element-172">
                  Precio Regular: $45.000
                </p>
                <div className="flex items-baseline justify-center gap-1" data-id="element-173">
                  <span className="text-5xl font-extrabold text-[#4DB8B8]" data-id="element-174">
                    $19.990
                  </span>
                  <span className="text-gray-500 font-medium" data-id="element-175">ARS</span>
                </div>
              </div>
            </div>

            <a href={PURCHASE_LINK} className="inline-flex items-center justify-center w-full md:w-auto px-10 py-5 text-xl font-bold text-white bg-[#FF8C42] rounded-full hover:bg-[#ff7a25] shadow-xl shadow-orange-200 transform hover:scale-105 transition-all duration-300 animate-pulse-slow" data-id="element-176">
              ACCEDER AL SISTEMA INCLUSIVO AHORA
              <ArrowRight className="ml-2" data-id="element-177" />
            </a>

            <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-178">
              <Shield size={16} data-id="element-179" />
              Compra 100% Segura y Garantizada
            </p>
          </div>
        </div>
      </section>

      {/* Promise/Footer */}
      <footer className="bg-[#2C3E50] text-white py-12 px-4" data-id="element-180">
        <div className="max-w-4xl mx-auto text-center" data-id="element-181">
          <h3 className="text-2xl font-bold mb-6" data-id="element-182">PROMESA FINAL</h3>
          <p className="text-lg mb-6 opacity-90" data-id="element-183">
            Mega Pack Inclusivo Infantil te devuelve:
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-184">
            {['Tiempo', 'Claridad', 'Seguridad', 'Organización', 'Tranquilidad', 'Confianza para incluir de verdad'].map((item, i) => <span key={i} className="bg-white/10 px-4 py-2 rounded-full text-sm font-medium border border-white/20" data-id="element-185">
                ✔ {item}
              </span>)}
          </div>
          <p className="text-xl font-medium mb-8" data-id="element-186">
            Entrá al aula con herramientas reales. Dejá de improvisar. Sentite
            acompañada. Volvé a disfrutar enseñar.
          </p>

          <div className="border-t border-white/10 pt-6 text-sm text-gray-400" data-id="element-187">
            <p data-id="element-188">
              &copy; 2024 Mega Pack Inclusivo. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}